import { EXPORT_FILTER_MODE_GREATER_THAN_OR_EQUAL } from './constants'

export const toDateInput = (date: Date) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

const addDays = (dateText: string, days: number) => {
  const date = new Date(`${dateText}T00:00:00`)
  date.setDate(date.getDate() + days)
  return toDateInput(date)
}

export const getPresetDateRange = (days: number) => {
  const today = toDateInput(new Date())
  const startDate = addDays(today, -days)

  return {
    startDate,
    endDate: today,
  }
}

export const getFiltersAfterModeChange = <
  T extends { mode: string; endDate: string }
>(
  prev: T,
  mode: string
) => ({
  ...prev,
  mode,
  endDate:
    mode === EXPORT_FILTER_MODE_GREATER_THAN_OR_EQUAL ? '' : prev.endDate,
})

export const getFiltersAfterStartDateChange = <T extends { startDate: string }>(
  prev: T,
  startDate: string
) => ({
  ...prev,
  startDate,
})

export const getErrorsAfterStartDateChange = <T extends { startDate?: string }>(
  prev: T
) => ({
  ...prev,
  startDate: undefined,
})
